import { render, staticRenderFns } from "./EstimateCommonNoteModal.vue?vue&type=template&id=451fe400&scoped=true&"
import script from "./EstimateCommonNoteModal.vue?vue&type=script&lang=js&"
export * from "./EstimateCommonNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fe400",
  null
  
)

export default component.exports